import Vue from 'vue'
import Vuex from 'vuex'

import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'
import state from './state'
import tagsView from './tagsView'
Vue.use(Vuex)
export default new Vuex.Store({
  modules:{
    tagsView
  },
  state,
  actions,
  getters,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js